import { Button } from "@heroui/react";
import { AUTH_URLS } from "@/shared/config";
import { YandexIcon } from "@/shared/ui";

export interface YandexLoginButtonProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const YandexLoginButton = ({
  className = "",
  size = "md",
}: YandexLoginButtonProps) => {
  const handleLogin = () => {
    window.location.href = AUTH_URLS.yandexLogin;
  };

  return (
    <Button
      size={size}
      className={`w-full font-medium bg-neutral-900 hover:bg-neutral-800 text-white border border-neutral-700/60 shadow-sm flex items-center justify-center gap-3 transition-all cursor-pointer ${className}`}
      onPress={handleLogin}
    >
      <YandexIcon className="w-5 h-5 flex-shrink-0" />
      <span>Войти с Яндекс ID</span>
    </Button>
  );
};
